import { DeviceStatus } from '@/features/devices/types/types'
import EditIcon from '@/shared/assets/icons/edit.svg?react'
import PauseIcon from '@/shared/assets/icons/pause.svg?react'
import PlayIcon from '@/shared/assets/icons/play.svg?react'
import { BaseButton } from '@/shared/components'

type Props = {
  deviceStatus: DeviceStatus
  onEdit: () => void
  onToggleStatus: () => void
}
export const ActionButtons = ({ deviceStatus, onEdit, onToggleStatus }: Props) => {
  return (
    <div className="flex gap-4">
      <BaseButton
        variant="setting"
        padding="none"
        radius="md"
        className="py-3 w-full md:w-[225px]"
        iconPosition="right"
        icon={<EditIcon className="text-primary dark:text-primary-dark" />}
        onClick={onEdit}
      >
        Переименовать
      </BaseButton>
      {(deviceStatus === DeviceStatus.Active || deviceStatus === DeviceStatus.Disabled) && (
        <BaseButton
          variant="primary"
          padding="none"
          radius="md"
          className="w-full md:w-[225px]"
          iconPosition="right"
          icon={
            deviceStatus === DeviceStatus.Active ? (
              <PauseIcon className="text-white" />
            ) : (
              <PlayIcon className="text-white" />
            )
          }
          onClick={onToggleStatus}
        >
          {deviceStatus === DeviceStatus.Active ? 'Остановить' : 'Запустить'}
        </BaseButton>
      )}
    </div>
  )
}
